import { render, staticRenderFns } from "./ContractPriceManagement.vue?vue&type=template&id=61a24ad6&scoped=true&"
import script from "./ContractPriceManagement.vue?vue&type=script&lang=js&"
export * from "./ContractPriceManagement.vue?vue&type=script&lang=js&"
import style0 from "./ContractPriceManagement.vue?vue&type=style&index=0&id=61a24ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a24ad6",
  null
  
)

export default component.exports